<template>
  <div>
    <h6 class="text-h6">
      {{ $t('global.items') }} ({{ order.details.length }})
    </h6>

    <image-dialog
      :show-dialog="showBigImageDialog"
      :src="bigImageSrc"
      @close="showBigImageDialog = false"
    />

    <v-data-table
      :headers="headers"
      :items="order.details"
      disable-pagination
      hide-default-footer
      class="details-table"
    >
      <!-- Photo column -->
      <template v-slot:item.photo="{ item }">
        <v-img
          :src="item.url_thumbnail"
          width="100"
          height="100"
          @click.stop="showBigImage(item)"
        />
      </template>

      <!-- Name column -->
      <template v-slot:item.name="{ item }">
        <div class="item-name">
          <v-icon v-if="item.category_type == 'frozen'">
            mdi-snowflake
          </v-icon>
          <v-icon v-if="item.category_type == 'variable_weight'">
            mdi-scale-balance
          </v-icon>
          {{ item.name }}
        </div>
      </template>

      <!-- Description column -->
      <template v-slot:item.description="{ item }">
        <div class="nowrap">
          {{ item.description }}
        </div>
      </template>

      <!-- Qty found column -->
      <template v-slot:item.qty_found="{ item }">
        <div class="nowrap">
          {{ item.quantity_found }} / {{ item.quantity }}
        </div>
      </template>

      <!-- Substitution column -->
      <template v-slot:item.substitution="{ item }">
        <div class="nowrap">
          {{ getSubstitutionText(item) }}
        </div>
      </template>

      <!-- Status column -->
      <template v-slot:item.status="{ item }">
        <status-block
          :color="getColorByOrderDetailStatus(item.status)"
          :label="$t(`detail_statuses.${item.status}`)"
        />
      </template>
    </v-data-table>

    <v-row>
      <v-col class="text-right">
        <!-- variable weight -->
        <span>
          <span class="label">
            <v-icon>mdi-scale-balance</v-icon>
            {{ $t('details_category.variable_weight') }}:
          </span>
          <span class="value">
            {{ order.details_summary.variable_weight }}
          </span>
        </span>

        <!-- frozen -->
        <span>
          <span class="label">
            <v-icon>mdi-snowflake</v-icon>
            {{ $t('details_category.frozen') }}:
          </span>
          <span class="value">
            {{ order.details_summary.frozen }}
          </span>
        </span>

        <!-- other -->
        <span>
          <span class="label">
            {{ $t('details_category.other') }}:
          </span>
          <span class="value">
            {{ order.details_summary.other }}
          </span>
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OrderDetailHelper from './../Helpers/OrderDetail'
import StatusColor from './../Helpers/StatusColor'
import ImageDialog from '@/components/System/Layout/ImageDialog'
import StatusBlock from './../UI/StatusBlock'

export default {

  components: {
    ImageDialog,
    StatusBlock
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      showBigImageDialog: false,
      bigImageSrc: ''
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('global.photo'), value: 'photo', class: 'photo-column', sortable: false },
        { text: this.$t('order.details.name'), value: 'name' },
        { text: this.$t('order.details.description'), value: 'description', sortable: false },
        { text: this.$t('order.details.qty'), value: 'quantity', sortable: false },
        { text: this.$t('order.details.qty_found'), value: 'qty_found', sortable: false },
        { text: this.$t('order.details.substitution'), value: 'substitution' },
        { text: this.$t('order.details.price'), value: 'price_formatted', align: 'end', sortable: false  },
        { text: this.$t('global.notes'), value: 'note' },
        { text: this.$t('global.status'), value: 'status' },
      ]
    }
  },

  methods: {
    getSubstitutionText: OrderDetailHelper.getSubstitutionText,
    getColorByOrderDetailStatus: StatusColor.getColorByOrderDetailStatus,
    /**
     * Show big image
     *
     * @param {Object} detail
     */
    showBigImage (detail) {
      if (detail.url_image) {
        this.bigImageSrc = detail.url_image
        this.showBigImageDialog = true
      } else {
        this.bigImageSrc = ''
        this.showBigImageDialog = false
      }
    }
  }
}
</script>

<style lang="scss">
.v-data-table .v-data-table__mobile-row {
  height: auto!important;
}

@media print {
  .details-table {
    th:nth-child(1),
    td:nth-child(1) {
      display: none;
    }

    th, td {
      padding: 0 5px!important;
    }
  }
}
</style>

<style lang="scss" scoped>
.details-table {
  .nowrap {
    white-space: nowrap;
  }

  .item-name {
    max-width: 500px;
  }
}
</style>
